if (!customElements.get('product-share')) {
  customElements.define(
    'product-share',
    class ProductShare extends HTMLElement {
      constructor() {
        super();

        this.trigger = this.querySelector('.product-share__trigger');
        this.panel = this.querySelector('.product-share__panel');
        this.copyButton = this.querySelector('.product-share__copy');
        this.message = this.querySelector('.product-share__message');
        this.supportsNativeShare = typeof navigator.share === 'function';

        this.trigger?.addEventListener('click', this.handleTriggerClick.bind(this));
        this.copyButton?.addEventListener('click', this.copyLink.bind(this));
        document.addEventListener('click', this.handleOutsideClick.bind(this));
        document.addEventListener('keydown', this.handleKeydown.bind(this));
      }

      get shareUrl() {
        return this.dataset.shareUrl || window.location.href;
      }

      get shareTitle() {
        return this.dataset.shareTitle || document.title;
      }

      handleTriggerClick(event) {
        event.stopPropagation();

        if (this.supportsNativeShare) {
          this.nativeShare();
          return;
        }

        const isOpen = this.panel.hasAttribute('hidden');
        if (isOpen) {
          this.openPanel();
        } else {
          this.closePanel();
        }
      }

      openPanel() {
        this.panel.removeAttribute('hidden');
        this.trigger.setAttribute('aria-expanded', 'true');
        this.message?.classList.add('hidden');
        this.message.textContent = '';
      }

      closePanel() {
        this.panel.setAttribute('hidden', '');
        this.trigger.setAttribute('aria-expanded', 'false');
      }

      handleOutsideClick(event) {
        if (!this.contains(event.target)) {
          this.closePanel();
        }
      }

      handleKeydown(event) {
        if (event.key === 'Escape') {
          this.closePanel();
        }
      }

      copyLink() {
        navigator.clipboard.writeText(this.shareUrl).then(() => {
          if (this.message) {
            this.message.textContent = window.accessibilityStrings?.shareSuccess || 'Link copied to clipboard';
            this.message.classList.remove('hidden');
          }
        });
      }

      nativeShare() {
        navigator.share({
          url: this.shareUrl,
          title: this.shareTitle,
        });
      }

      updateUrl(url, title) {
        if (url) {
          this.dataset.shareUrl = url;
        }
        if (title) {
          this.dataset.shareTitle = title;
        }
      }
    }
  );
}
